export default __webpack_public_path__ + "static/media/supper.5ea225df.svg";